import React, { useState, useEffect } from 'react'
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import OnioTabs from "../../Components/OnioTabs/index";
import Button from '@mui/material/Button';
import { Avatar, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { RgbColorPicker } from "react-colorful";
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import { TabMenus } from '../../Utils/Types'
import { HslColorPicker, RgbColor } from "react-colorful";


// import useMediaQuery from '@mui/material/useMediaQuery';

import './index.css'
import {
  LightsSwitch, Icons, lightsMenu, LightsType, ScrollGridStyle, colorPickerGridStyle,
  SlidersStyle, LightsGrid
} from './style';


const LightsPage = () => {

  // const matches = useMediaQuery('(max-width:1024px)');
  const [color, setColor] = useState({ r: 200, g: 150, b: 35 });
  const [lightCard, setLightCard] = useState(0);



  const [selectedLight, setSelectedLight] = useState<number>(50);
  const [R, setR] = useState<number>(87);
  const [G, setG] = useState<number>(66);
  const [B, setB] = useState<number>(43);

  const handleSelectedLight = (event: Event, newValue: number | number[]) => {
    setSelectedLight(newValue as number);
  };
  const handleRGB = (event: Event, newValue: number | number[]) => {
    let target = event.target as HTMLInputElement;
    switch (target.name) {
      case "r":
        setColor({ ...color, r: newValue as number })
        setR(newValue as number);
        break;
      case "g":
        setColor({ ...color, g: newValue as number })
        setG(newValue as number);
        break;
      case "b":
        setColor({ ...color, b: newValue as number })
        setB(newValue as number);
        break;
    }
  }

  useEffect(() => {
    setR(color.r)
    setG(color.g)
    setB(color.b)
  }, [color])
  return (
    <Container maxWidth="lg">
      <OnioTabs menu={TabMenus} />

      <Grid container spacing={2} sx={{ mt: 4 }}>

        <Grid sx={LightsGrid} container xs={12} md={8} spacing={2} >
          <Grid xs={4} ip={3.5} md={4} lg={4}> <LightsSwitch> <Avatar sx={{ width: 25, height: 25 }} src={Icons.BulbOffIcon} /> Turn off all</LightsSwitch></Grid>
          <Grid xs={4} ip={3.5} md={3.5} lg={4}> <LightsSwitch> <Avatar sx={{ width: 25, height: 25 }} src={Icons.BilbOnIcon} /> Turn on all</LightsSwitch></Grid>
        </Grid>

      </Grid>

      <Grid container spacing={2} sx={{ ...LightsGrid, mt: 5.5 }}>
        <Grid xs={12}>
          <Divider light sx={{ height: 0.51, border: "1px solid #3E3E3E" }} />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 4 }}>
        <Grid sx={ScrollGridStyle}>

          <div className="lights-scroll">

            {
              lightsMenu.map((ele, i) => {
                return (
                  <LightsType onClick={() => setLightCard(i)} sx={{ backgroundColor: lightCard === i ? "#D4DD06 !important" : "#212121" }} className="lights-scroll-item" key={i}>
                    <Typography sx={{ color: lightCard === i ? "#1A1A1A" : "#FFFFFF", textTransform: "capitalize" }}>{ele.name}</Typography>
                    <Typography variant="caption" sx={{ color: lightCard === i ? "#FFFFFF" : "#909090" }}>{ele.type}</Typography>
                  </LightsType>
                )
              })
            }

          </div>
        </Grid>

      </Grid>

      <Grid container spacing={2} sx={{ mt: 2.5 }}>
        <Grid xs={12}>
          <Divider light sx={{ height: 0.51, border: "1px solid #3E3E3E" }} />
        </Grid>
      </Grid>

      <Grid className={"sliders"} container spacing={2} sx={{ mt: 5.5 }}>
        <Grid ip={12} md={6}>
          <Grid ip={12} md={12} container>
            <Grid ip={12} md={12}>
              <Typography sx={{ color: "#909090", fontSize: 16, fontWeight: "400" }}>SELECTED LIGHT</Typography>
            </Grid>
            <Grid ip={12} md={12} className={"selected-light"}>
              <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                <Avatar sx={{ width: 25, height: 25 }} src={Icons.BulbOffIcon} />
                <Slider size="small" sx={SlidersStyle} aria-label="selected light" value={selectedLight} onChange={handleSelectedLight} />
                <Avatar sx={{ width: 25, height: 25 }} src={Icons.BilbOnIcon} />
              </Stack>
            </Grid>
            <Grid ip={12} md={12}>
              <Typography sx={{ color: "#909090", fontSize: 16, fontWeight: "400" }}>RGB CONTROL</Typography>
            </Grid>
            <Grid ip={12} md={12}>
              <Stack className="red-slider stack" spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                <Typography variant="caption">R</Typography>
                <Slider max={255} name="r" size="small" sx={SlidersStyle} aria-label="selected light" value={R} onChange={handleRGB} />
                <Typography variant="caption">{R}</Typography>
              </Stack>
              <Stack className="green-slider stack" spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                <Typography variant="caption">G</Typography>
                <Slider max={255} name="g" size="small" sx={SlidersStyle} aria-label="selected light" value={G} onChange={handleRGB} />
                <Typography variant="caption">{G}</Typography>
              </Stack>
              <Stack className="blue-slider stack" spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                <Typography variant="caption">B</Typography>
                <Slider max={255} name="b" size="small" sx={SlidersStyle} aria-label="selected light" value={B} onChange={handleRGB} />
                <Typography variant="caption">{B} </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>

        <Grid ip={12} md={6} sx={colorPickerGridStyle} className="color-grid">
          <RgbColorPicker className="colorPicker" color={color} onChange={setColor} />
        </Grid>
      </Grid>


    </Container>

  )
}

export default LightsPage